import { 
  SET_LOGIN_REFERRAL,
  IS_FROM_WEB_APPS
} from '../constants';

const initialState = {
  loginReferral: {
    isWebApp: false
  }
}


export default function productsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_LOGIN_REFERRAL:
      localStorage.setItem(IS_FROM_WEB_APPS, action.payload);
      return {
        ...state,
        loginReferral:{
          isWebApp: action.payload
        }
      };
          
    default:
      return state;
  }
}
